import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from './auth';
import { AdminLayout } from './components/AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { UsersPage } from './pages/UsersPage';
import { LayoutConfigPage } from './pages/LayoutConfigPage';
import { PopupsPage } from './pages/PopupsPage';
import { CommunicationsPage } from './pages/CommunicationsPage';
import { SharePointConfigPage } from './pages/SharePointConfigPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/companies" replace />} />
            <Route path="companies" element={<CompaniesPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="layout" element={<LayoutConfigPage />} />
            <Route path="popups" element={<PopupsPage />} />
            <Route path="communications" element={<CommunicationsPage />} />
            <Route path="sharepoint" element={<SharePointConfigPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
